import React from 'react';
import { hasLocationSupport } from '../Common/HOC/LocationSupport';
import { withRouter } from 'react-router';
import autoCompleteFeature from './AutoCompleteFeature';
import config from '../../config';

class AutoCompleteSearchBarMobile extends React.Component {
    constructor(props){
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.props = props;
        this.state = {
            results: '',
            value: '',
            delayInterval: config.typingDelay,
            limit: 5,
            maxLength: 25,
            enterKeyFlag: false,
            loadingFlag: false,
            openSearchField: false,
        };
        this.timer;
        const {
            store,
        } = this.props;
    }

    handleOnClick() {
        this.toggleDisplaySearchBar();
    }
    
    toggleDisplaySearchBar() {
        this.setState({
            openSearchField: !this.state.openSearchField,
        });
    }
    
    renderSearchIcon() {
      return (
        <i
          className='fa fa-search d-sm-none'
          onClick={this.handleOnClick}
        >
        </i>
      );
    }

    renderSearchField() {
      const pathName  = this.props.tRoute('/search');
      return (
        <div
          className='search-mobile'
        >
          <div className="search-mobile__content">
            <i className='search-mobile__icon--left fa fa-search'></i>
            <div className="AutoCompleteSearchBarMobile">
                <input 
                  id="input-search-bar" 
                  type="text" 
                  placeholder="Search..." 
                  onChange={this.onTextChanged} 
                  onKeyPress={(event) => this.handleKeyPress(event, this.props.tRoute('/search'))}
                  autoComplete="off"
              />
              <i id="loading-icon" className="fa fa-spinner fa-spin load-icon"/>
              {this.renderSuggestions()}
            </div>
            <i
              className='search-mobile__icon--right fa fa-close'
              onClick={this.handleOnClick}
            >
            </i>
          </div>
        </div>
      );
    }

    render() {
      if (this.state.openSearchField) {
        return this.renderSearchField();
      }

      return this.renderSearchIcon();
    }

    onTextChanged = (event) => {
        document.getElementById('loading-icon').style.visibility = 'visible';
        this.setState({loadingFlag: false});
        this.search(event);
    }

    search = (event) => {
        const value = event.target.value;

        this.setState({enterKeyFlag: false});

        if (value === '') {
            this.setState({results: ''});
            document.getElementById('loading-icon').style.visibility = 'hidden';
        }

        clearTimeout(this.timer);
        this.timer = setTimeout(this.dropDownView, this.state.delayInterval, value);
    }

    dropDownView = (value) => {
        this.setState({value: value, loadingFlag: true});

        let query = `?limit=${this.state.limit}&offset=0&query_param=${value}&search_type=product,category`;
        fetch(`${config.localeApi}/search${query}`)
        .then((response) => response.json())
        .then((data) => this.setState({results: data.data.results})); 

    }

    handleKeyPress = (event, pathName) => {
        if (event.key === 'Enter') {
            this.props.updateLocationForGlobalSearch(event.target.value, pathName);
            this.setState({results: '', enterKeyFlag: true});
            this.toggleDisplaySearchBar();
            document.getElementById('loading-icon').style.visibility = 'hidden';
        }
    }
 
    handleSearchAll = (query) => {
        const pathName = this.props.tRoute('/search');
        this.props.updateLocationForGlobalSearch(query, pathName);
        this.setState({results: '', enterKeyFlag: true});
        this.toggleDisplaySearchBar();
        document.getElementById('loading-icon').style.visibility = 'hidden';
    }
 
    toggleDisplaySearchBar() {
        this.setState({
          openSearchField: !this.state.openSearchField,
        });
    }
    
    handleOnClickOutsideDropDown = (event) => {
        if (!(event.target.id === 'input-search-bar' || event.target.className.includes('dropdown')) && this.state.openSearchField) {
            this.setState({results: ''});
            this.handleOnClick();
        }
    };

    renderSuggestions() {
        const products = this.state.results;
        const currency = this.props.store.currency.symbol;
        
        if (this.state.enterKeyFlag || products === '') {
            return null;
        }

        if (this.state.loadingFlag){
            document.getElementById('loading-icon').style.visibility = 'hidden';
        }

        const { 
            categories,
            themes,
            categoryIsEmpty,
            themeIsEmpty,
        } = this.props.renderSuggestions(products);

        return this.props.showDropDown(categories, themes, categoryIsEmpty, themeIsEmpty, currency, this.state, this.handleSearchAll);
    }
    
    componentDidMount() {
        document.addEventListener("touchend", this.handleOnClickOutsideDropDown);
    }

    componentWillUnmount() {
        document.removeEventListener("touchend", this.handleOnClickOutsideDropDown);
    }

}

export default withRouter(hasLocationSupport(autoCompleteFeature(AutoCompleteSearchBarMobile)));


// WEBPACK FOOTER //
// ./src/Nav/AutoCompleteSearchBarMobile.js